import { render, staticRenderFns } from "./ShowActivities.vue?vue&type=template&id=65f4af6d&scoped=true&"
import script from "./ShowActivities.vue?vue&type=script&lang=js&"
export * from "./ShowActivities.vue?vue&type=script&lang=js&"
import style0 from "./ShowActivities.vue?vue&type=style&index=0&id=65f4af6d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f4af6d",
  null
  
)

export default component.exports